var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enable)?_c('div',{staticClass:"d-flex justify-content-center align-items-center",attrs:{"id":"hover"}},[_c('img',{attrs:{"src":require("@/assets/images/loading.gif"),"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }